import { GETTEXT_ALL_FACILITIES, gettextSeeAllPatients, storage, STORAGE_KEYS } from '@/shared/lib';
import { create } from 'zustand';
import type { UserState } from './user.types';

const ALL_FACILITIES = { label: GETTEXT_ALL_FACILITIES, value: 'All facilities' };
const YOUR_STUDIES = { label: gettextSeeAllPatients('Your studies'), value: 'Your studies' };

// Đọc một lần khi module load, giống initialState cũ (module-level const).
export const defaultUserState = {
  me: {} as any,
  selectedFacility:
    storage.getJson<any>(STORAGE_KEYS.selectedFacilityLocalStorage, null) || ALL_FACILITIES,
  selectedTypeSeePatients:
    storage.getJson<any>(STORAGE_KEYS.selectedTypeSeePatientsLocalStorage, null) || YOUR_STUDIES,
};

// Logout KHÔNG reset về defaultUserState. root-reducer.ts:34-43 ghi đè hai lựa chọn bằng giá
// trị cố định (không đọc localStorage) sau khi auth.logout() đã xoá localStorage.
export const logoutUserState = {
  me: {} as any,
  selectedFacility: ALL_FACILITIES,
  selectedTypeSeePatients: YOUR_STUDIES,
};

/**
 * Zustand store hook holding the signed-in user, their selected facility and their see-patients scope, seeded from the default user state. Exposes `setMe`, `changeSelectedFacility` and `changeSelectedTypeSeePatients`, each writing its single field.
 *
 * @returns Hook that reads the user state and exposes its setters.
 */
const useUserStore = create<UserState>()((set) => ({
  ...defaultUserState,
  setMe: (me) => set({ me }),
  changeSelectedFacility: (selectedFacility) => set({ selectedFacility }),
  changeSelectedTypeSeePatients: (selectedTypeSeePatients) => set({ selectedTypeSeePatients }),
}));

export default useUserStore;
